// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sellingFastBadge":"sellingFastBadge_UG7go"};